import { Component } from '@angular/core';

@Component({
  selector: 'app-qrcode-icon',
  templateUrl: './qrcode-icon.component.html'
})
export class QrcodeIconComponent {

}
